module.exports = __webpack_public_path__ + "static/media/red-pay.d6193784.png";